/**************************************************
 * Nombre:       Main_Crm
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Tablero_Crm from "./Tablero_Crm";
import Cabecera_Crm from "./Cabecera_Crm";
import {useEffect, useRef, useState} from "react";
import {where} from "firebase/firestore";
import dayjs from "dayjs";

const Main_Crm = ({config}) => {
    const refe = useRef(null);
    const coleccion = 'potenciales'
    const [carga, setCarga] = useState(false);
    const [escogido, setEscogido] = useState('Todos');
    const [wheresAdicionaless, setWheresAdicionales] = useState([]);

    const verActividadesHoy = () => {

        setEscogido('Hoy')
        let hoyInicia = dayjs().set('hours', 0).set('minutes', 1).valueOf();
        let hoyFin = dayjs().set('hours', 23).set('minutes', 59).valueOf();
        setWheresAdicionales([where('fechaProximoContacto', '>=', hoyInicia), where('fechaProximoContacto', '<=', hoyFin)]);
    }

    const verSinActividades = () => {
        setEscogido('Sin')
        setWheresAdicionales([where('fechaProximoContacto', '==', null)]);
    }

    const verTodos = () =>{
        setEscogido('Todos')
        setWheresAdicionales([]);
    }

    const cargar = () => {
        setCarga(!carga);
    }

    useEffect(() => {

    }, [carga]);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{pb: 4}}
        >

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Cabecera_Crm refe={refe} verActividadesHoy={verActividadesHoy} verSinActividades={verSinActividades}
                              escogido={escogido} verTodos={verTodos} />
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                <Tablero_Crm refe={refe} config={config} coleccion={coleccion} cargar={cargar} carga={carga}
                             wheresAdicionaless={wheresAdicionaless}/>
            </Grid>

        </Grid>
    )

}
export default Main_Crm